<template>
  <Loader :loader="loaderActive"/>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      content-class="modal-content">
      <span class="modal__header">
        <img :src="rankingUser.image_url" :alt="rankingUser.name">
        <span class="modal__user-name">{{ rankingUser.name }}</span>
        <span class="modal__user-level">{{ $t('LEVEL') }} {{ convertNumberToLangWise(rankingUser.level) }}</span>
      </span>
    <span class="modal__details">
        <span class="d-flex justify-content-between align-items-center mb-1 border-bottom pt-2 pb-2">
          <span>{{ $t('TOTAL_POINTS') }} </span>
          <span style="color: #F42F75">{{ convertNumberToLangWise(rankingUser.total_point) }}</span>
        </span>
        <span class="d-flex justify-content-between align-items-center mb-1 border-bottom pt-2 pb-2">
          <span>{{ $t('HIGH_SCORE_IN_ANY_TOPIC') }}</span>
          <span style="color: #F42F75">{{ convertNumberToLangWise(rankingUser.topic_high_score) }}</span>
        </span>
        <span class="d-flex justify-content-between align-items-center mb-1 border-bottom pt-2 pb-2">
          <span>{{ $t('TOURNAMENT_WIN') }} </span>
          <span style="color: #F42F75">{{
              convertNumberToLangWise(rankingUser.tournament_win)
            }}/{{ convertNumberToLangWise(rankingUser.tournament_played) }}</span>
        </span>
      </span>
    <div v-if="! friendRequest">
      <argon-button fullWidth
                    color="dark"
                    variant="gradient"
                    class="my-4 ml-2"
                    style="background: #3EAAFF;" v-if="rankingUser.friendship_status === 'friend' && rankingUser.user_id !== auth.user_id">
        {{ $t('CHALLENGE_NOW') }}
      </argon-button>
      <argon-button fullWidth
                    color="dark"
                    variant="gradient"
                    class="my-4 ml-2"
                    @click="friendRequestSend"
                    style="background: #3EAAFF;" v-if="rankingUser.friendship_status !== 'friend' && rankingUser.user_id !== auth.user_id">
        {{ $t('ADD_FRIEND') }}
      </argon-button>
    </div>
    <div v-else>
      <argon-button fullWidth
                    color="dark"
                    variant="gradient"
                    class="my-4 ml-2"
                    style="background: #FFFFFF; border: 1px solid green; color: green;">
        {{ $t('REQUEST_SENT') }}
      </argon-button>
    </div>
  </vue-final-modal>
</template>

<script>
import Loader from "@/views/components/Loader";
import {VueFinalModal} from 'vue-final-modal';
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import ArgonButton from "@/components/ArgonButton.vue";
import {sendRequest} from "@/http/axios.method";

export default {
  name: "RankingModal",
  props: ['modalShow', 'rankingUser'],
  components: {
    Loader,
    VueFinalModal,
    ArgonButton
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      showModal: this.modalShow,
      auth: this.$store.state.authUser,
      friendRequest: false,
    }
  },
  created() {
    this.friendRequest = this.rankingUser.friendship_status === 'requested';
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    modalClose() {
      this.emitter.emit('modal-close-event', {'eventContent': false})
    },
    friendRequestSend() {
      sendRequest('post', 'v2.0/friend-request-send', {user_id: this.rankingUser.user_id}, this.config)
          .then(() => {
            this.loaderActive = false;
            this.friendRequest = true;
            this.emitter.emit('update-user-event', {'userId': this.rankingUser.user_id});
          })
          .catch(() => {
            this.loaderActive = false;
          });
    }
  }
}
</script>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .modal-content {
  display: flex;
  flex-direction: column;

  margin-left:10%;
  margin-right:10%;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}
@media only screen and (min-width: 1200px) {
  :deep .modal-content {

    margin-left:19%;
    margin-right:19%;


  }
}

.dark-mode div:deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
